import React from "react";
import Icon from "../icons/Icon";
import iconsList from "../icons/iconsList";
import classes from "./DateTimeField.module.css";

const DateTimeField = ({ inputId, label, value, onChange, min }) => (
    <div className={classes.Field}>
        <label className={classes.Label} htmlFor={inputId}>
            <Icon name={iconsList.calendarWithoutNumbers} size={12} className={classes.CalIcon} />
            {label}
        </label>
        <div className={classes.InputWrap}>
            <input
                id={inputId}
                type="datetime-local"
                value={value?.slice(0, 16) ?? ""}
                onChange={(e) => onChange(e.target.value || null)}
                className={classes.DateTimeInput}
                min={min}
            />
        </div>
    </div>
);

export default DateTimeField;
